<template>
    <div class="evaluation-count">
        <div class="title-group">
            <h1 class="title">評價</h1>
            <div class="all-count">
                ({{rateCommentTotal}}個真實房客的評價)
            </div>
        </div>
        <div class="evaluation">
            <div class="average-eval">
                <div class="average">
                    {{rateAverage.toFixed(1)}}
                </div>
                <div ref="stars" class="stars">
                    <img src="@/assets/img/shareHouse/star_gray.svg" alt="">
                    <img src="@/assets/img/shareHouse/star_gray.svg" alt="">
                    <img src="@/assets/img/shareHouse/star_gray.svg" alt="">
                    <img src="@/assets/img/shareHouse/star_gray.svg" alt="">
                    <img src="@/assets/img/shareHouse/star_gray.svg" alt="">
                </div>
            </div>
            <div class="bar-chart">
                <ul>
                    <li>
                        5
                        <div class="bar-group">
                            <div class="bar bg-bar"></div>
                            <div class="bar percent-bar" :style="'width:'+getRatePercent(4)+'%'"></div>
                        </div>
                    </li>
                    <li>
                        4
                        <div class="bar-group">
                            <div class="bar bg-bar"></div>
                            <div class="bar percent-bar" :style="'width:'+getRatePercent(3)+'%'"></div>
                        </div>
                    </li>
                    <li>
                        3
                        <div class="bar-group">
                            <div class="bar bg-bar"></div>
                            <div class="bar percent-bar" :style="'width:'+getRatePercent(2)+'%'"></div>
                        </div>
                    </li>
                    <li>
                        2
                        <div class="bar-group">
                            <div class="bar bg-bar"></div>
                            <div class="bar percent-bar" :style="'width:'+getRatePercent(1)+'%'"></div>
                        </div>
                    </li>
                    <li>
                        1
                        <div class="bar-group">
                            <div class="bar bg-bar"></div>
                            <div class="bar percent-bar" :style="'width:'+getRatePercent(0)+'%'"></div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    mounted () {
        this.setStars()
    },
    watch: {
        rateAverage: {
            handler: function (val) {
                this.setStars()
            },
            immediate: true,
        }
    },
    methods: {
        setStars: function () {
            if(this.$refs.stars.children){
                let stars = this.$refs.stars.children
                for (let i = 0; i < this.rateAverage; i++) {
                    const star = stars[i];
                    star.src = require('../../assets/img/shareHouse/star_orange.svg')
                }
            }
        },
        getRatePercent: function (index) {
            let rateCount = this.rateCountList[index].rateCount
            let heightestRate = this.heightestRate.count
            if(heightestRate == 0){
                return 0
            }else{
                return (rateCount/heightestRate) * 100
            }
        }
    },
    computed: {
        heightestRate: function () {
            let maxCount = 0
            let MaxRateStar = 0

            this.rateCountList.map( item => {
                // console.log(item)
                if( item.rateCount > maxCount){
                    maxCount = item.rateCount
                    MaxRateStar = item.rate
                }
            })
            return { 'star': MaxRateStar, 'count': maxCount}
        },
        ...mapGetters({
            rateAverage: 'GET_SHARE_HOUSE_RATE_AVERAGE',
            rateCommentTotal: 'GET_SHARE_HOUSE_RATE_COMMENT_TOTAL',
            rateCountList: 'GET_SHARE_HOUSE_RATE_COUNT_LIST',
        })
    },
}
</script>
<style lang="scss" scoped>
    .evaluation-count{
        .title-group{
            display: flex;
            align-items: center;
            margin-bottom: 23px;
            h1.title{
                font-size: 28px;
                font-weight: 500;
                line-height: 1.47;
                margin-right: 12px;
                color: #3a455f;
            }
            .all-count{
                font-size: 20px;
                color: #909090;
            }
        }
        .evaluation{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .average-eval{
                width: 84px;
                .average{
                    font-size: 50px;
                    font-weight: 500;
                    margin-bottom: 12px;
                }
                .stars{
                    img{
                        width: 14px;
                    }
                }
            }
            .bar-chart{
                width: 81.81%;
                ul{
                    li{
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        font-size: 16px;
                        font-weight: 500;
                        margin-bottom: 3px;
                        .bar-group{
                            position: relative;
                            width: 96.34%;
                            .bar{
                                width: 100%;
                                height: 6px;
                                border-radius: 3px;
                                background-color: #dfdfdf;
                            }
                            .bg-bar{
                                position: absolute;
                                z-index: -1;
                            }
                            .percent-bar{
                                background-color: #ff9275;
                            }
                        }
                    }
                }
            }
        }
        
    }
    @media (max-width: 992px) {
        .evaluation-count{
            .title-group{
                display: flex;
                align-items: center;
                margin-bottom: 16px;
                h1.title{
                    font-size: 20px;
                    font-weight: 500;
                    line-height: 1;
                    margin-right: 8px;
                    color: #3a455f;
                }
                .all-count{
                    font-size: 14px;
                }
            }
            .evaluation{
                .average-eval{
                    width: 19.70%;
                    .average{
                        font-size: 40px;
                        font-weight: 500;
                        margin-bottom: 10px;
                    }
                    .stars{
                        img{
                            width: 10px;
                        }
                    }
                }
                .bar-chart{
                    width: 75.29%;
                    ul{
                        li{
                            font-size: 12px;
                            margin-bottom: 7px;
                            .bar-group{
                                position: relative;
                                width: 95%;
                                .bar{
                                    width: 100%;
                                    height: 6px;
                                    border-radius: 3px;
                                    background-color: #dfdfdf;
                                }
                                .bg-bar{
                                    position: absolute;
                                    z-index: -1;
                                }
                                .percent-bar{
                                    background-color: #ff9275;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/evaluationCount.vue